import demographicInformationJSON from './jsonsAdultVirginia/demographicInformationJSON';
import presentingProblemJSON from './jsonsAdultVirginia/presentingProblemJSON';
import medicalHistoryJSON from './jsonsAdultVirginia/medicalHistoryJSON';
import educationHistoryJSON from './jsonsAdultVirginia/educationHistorJSON';
import alcoholHistoryJSON from './jsonsAdultVirginia/alcoholHistoryJSON';
import legalHistoryJSON from './jsonsAdultVirginia/legalHistoryJSON';
import familyHistoryJSON from './jsonsAdultVirginia/familyHistoryJSON';
import behavioralHistoryJSON from './jsonsAdultVirginia/behavioralHistoryJSON';
import summaryRecomendationsJSON from './jsonsAdultVirginia/summaryRecomendationsJSON';
import asamCriteriaJSON from './jsonsAdultVirginia/asamCriteriaJSON';
import mseJSON from './jsonsAdultVirginia/mseJSON';
import collateralJSON from './jsonsAdultVirginia/collateralJSON';
import strengthsJSON from './jsonsAdultVirginia/strengthsJSON';
import suggestedRecomendation from './jsonsAdultVirginia/suggestedRecomendation';
import problemList from './jsonsAdultVirginia/problemList';
import caseManagementGoals from './jsonsAdultVirginia/caseManagementGoals';
import progressNotesJSON from './progressNotesPattern';
import supplementaryInformationJSON from './jsonsAdultVirginia/supplementaryInformationJSON';

const adultVirginiaPattern = [
  //========================================================================================
  /*                                                                                      *
   *                                Supplementary Information                               *
   *                                                                                      */
  //========================================================================================
  supplementaryInformationJSON,
  //========================================================================================
  /*                                                                                      *
   *                                Demographic Information                               *
   *                                                                                      */
  //========================================================================================
  demographicInformationJSON,
  //========================================================================================
  /*                                                                                      *
   *                         Presenting Problem/Primary Complaint                         *
   *                                                                                      */
  //========================================================================================

  presentingProblemJSON,
  //========================================================================================
  /*                                                                                      *
   *                                    Medical History                                   *
   *                                                                                      */
  //========================================================================================
  medicalHistoryJSON,
  //========================================================================================
  /*                                                                                      *
   *                      Education, Employment and Military History                      *
   *                                                                                      */
  //========================================================================================
  educationHistoryJSON,
  //========================================================================================
  /*                                                                                      *
   *                               Drug and Alcohol History                               *
   *                                                                                      */
  //========================================================================================

  alcoholHistoryJSON,
  //========================================================================================
  /*                                                                                      *
   *                                         Legal History                                       *
   *                                                                                      */
  //========================================================================================
  legalHistoryJSON,
  //========================================================================================
  /*                                                                                      *
   *                                    Family History                                    *
   *                                                                                      */
  //========================================================================================
  familyHistoryJSON,
  //========================================================================================
  /*                                                                                      *
   *                               Behavioral Health History                              *
   *                                                                                      */
  //========================================================================================
  behavioralHistoryJSON,
  //========================================================================================
  /*                                                                                      *
   *                           Diagnosis/Summary/Recommendations                          *
   *                                                                                      */
  //========================================================================================
  // summaryRecomendationsJSON,
  //========================================================================================
  /*                                                                                      *
   *                                       OPTIONAL                                       *
   *                                                                                      */
  //========================================================================================

  // {
  //   section: "OPTIONAL",
  //   topic: "OPTIONAL SECTIONS. CHECK TO INCLUDE",
  //   checked: "false",
  //   // access: "private",
  //   color: "info",
  //   body: [],
  // },
  //========================================================================================
  /*                                                                                      *
   *                                     ASAM Criteria                                    *
   *                                                                                      */
  //========================================================================================
  asamCriteriaJSON,
  //========================================================================================
  /*                                                                                      *
   *                            Mental Status Examination (MSE)                           *
   *                                                                                      */
  //========================================================================================

  mseJSON,
  //========================================================================================
  /*                                                                                      *
   *                                Collateral Information                                *
   *                                                                                      */
  //========================================================================================

  collateralJSON,
  //========================================================================================
  /*                                                                                      *
   *                               Strengths and Challenges                                *
   *                                                                                      */
  //========================================================================================
  strengthsJSON,
  //========================================================================================
  /*                                                                                      *
   *                                     Problem List                                     *
   *                                                                                      */
  //========================================================================================

  problemList,
  //========================================================================================
  /*                                                                                      *
   *                           Diagnosis/Summary/Recommendations                          *
   *                                                                                      */
  //========================================================================================
  summaryRecomendationsJSON,
  //========================================================================================
  /*                                                                                      *
   *                           Diagnosis/Summary/Recommendations                          *
   *                                                                                      */
  //========================================================================================
  suggestedRecomendation,
  caseManagementGoals,
  //========================================================================================
  /*                                                                                      *
   *                                   progressNotesJSON                                  *
   *                                                                                      */
  //========================================================================================
  // progressNotesJSON,
];

export default adultVirginiaPattern;
